import { Link } from "react-router-dom";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageFatherB.module.scss";

function PageFatherB() {
  const getImgSet = useImgSet();

  const heading = getImgSet("heading__p23", "png", s.heading);
  const paperA = getImgSet("paper__a__p23", "jpg", s.paperA);
  const paperB = getImgSet("paper__b__p23", "jpg", s.paperB);
  const paperC = getImgSet("paper__c__p23", "jpg", s.paperC);
  const paperD = getImgSet("paper__d__p23", "jpg", s.paperD);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__01", "png", s.img__a);

  return (
    <div className={s.root}>
      <div className={s.aside_left}>
        {heading}
        {paperA}
      </div>
      <div className={s.inner}>
        {paperB}
        {paperC}
      </div>
      <div className={s.aside_right}>
        <div className={s.aside_right_inner}>
          {imgA}
          <Link to="/father/a" className={s.back}>
            {back}
          </Link>
        </div>
        <div className={s.aside_right_img}>{paperD}</div>
      </div>
    </div>
  );
}

export default withLayoutSimple(PageFatherB, false, false);
